/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsBase.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsBase>): AdditionalResourceDetailsBase {
        let obj = Object.assign(new AdditionalResourceDetailsBase(), model);
        AdditionalResourceDetailsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsBase>): AdditionalResourceDetailsBase {
        if (!model) return null;
        return AdditionalResourceDetailsBase.newInstance(<AdditionalResourceDetailsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsBase) {
        if (!obj) return;

        models.AdditionalResourceDetailsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsBase): boolean {
        switch (obj.__type)
        {
            case "AdditionalResourceDetailsForFinopsBillingAzureAdvisor":
                Object.setPrototypeOf(obj, models.AdditionalResourceDetailsForFinopsBillingAzureAdvisor.prototype);
                break;
            case "AdditionalResourceDetailsForFinopsBudgetSystem":
                Object.setPrototypeOf(obj, models.AdditionalResourceDetailsForFinopsBudgetSystem.prototype);
                break;
            case "AdditionalResourceDetailsForFinopsConfigAdvisor":
                Object.setPrototypeOf(obj, models.AdditionalResourceDetailsForFinopsConfigAdvisor.prototype);
                break;
            case "AdditionalResourceDetailsForFinopsCustomBilling":
                Object.setPrototypeOf(obj, models.AdditionalResourceDetailsForFinopsCustomBilling.prototype);
                break;
            case "AdditionalResourceDetailsForFinopsGovernanceSystem":
                Object.setPrototypeOf(obj, models.AdditionalResourceDetailsForFinopsGovernanceSystem.prototype);
                break;
            case "AdditionalResourceDetailsForFinopsIdleAwsAdvisor":
                Object.setPrototypeOf(obj, models.AdditionalResourceDetailsForFinopsIdleAwsAdvisor.prototype);
                break;
            case "AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor":
                Object.setPrototypeOf(obj, models.AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor.prototype);
                break;
            case "AdditionalResourceDetailsForFinopsReservationRecommendations":
                Object.setPrototypeOf(obj, models.AdditionalResourceDetailsForFinopsReservationRecommendations.prototype);
                break;
            case "AdditionalResourceDetailsForFinopsScheduleRecommendation":
                Object.setPrototypeOf(obj, models.AdditionalResourceDetailsForFinopsScheduleRecommendation.prototype);
                break;
            case "AdditionalResourceDetailsForFinopsTagsSystem":
                Object.setPrototypeOf(obj, models.AdditionalResourceDetailsForFinopsTagsSystem.prototype);
                break;
            case "AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer":
                Object.setPrototypeOf(obj, models.AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer.prototype);
                break;
            case "AdditionalResourceDetailsForFinopsUtilizationAdvisor":
                Object.setPrototypeOf(obj, models.AdditionalResourceDetailsForFinopsUtilizationAdvisor.prototype);
                break;
            case "AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor":
                Object.setPrototypeOf(obj, models.AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof AdditionalResourceDetailsBase)[] {
        return [
            models.AdditionalResourceDetailsForFinopsBillingAzureAdvisor,
            models.AdditionalResourceDetailsForFinopsBudgetSystem,
            models.AdditionalResourceDetailsForFinopsConfigAdvisor,
            models.AdditionalResourceDetailsForFinopsCustomBilling,
            models.AdditionalResourceDetailsForFinopsGovernanceSystem,
            models.AdditionalResourceDetailsForFinopsIdleAwsAdvisor,
            models.AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor,
            models.AdditionalResourceDetailsForFinopsReservationRecommendations,
            models.AdditionalResourceDetailsForFinopsScheduleRecommendation,
            models.AdditionalResourceDetailsForFinopsTagsSystem,
            models.AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer,
            models.AdditionalResourceDetailsForFinopsUtilizationAdvisor,
            models.AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor,
        ];
    }

    fixupFields() {
    }

}
